/// <reference path="../../apps/typings/customTds.d.ts" />
import { AppUtils } from '../../shared/utils/index';


export namespace Format {
	export const ISODATE_SHORT = 'YYYY-MM-DD';
	export const ISODATE_SHORT_INV = 'DD-MM-YYYY';
	/**
	 * Converts a date in format "DD.MM.YYYY" to iso format "yyyy-MM-ddThh:mm:ss.000Z".
	 *
	 * @param viewDate - date in format "DD.MM.YYYY", may be undefined/empty
	 * @returns iso date in format "yyyy-MM-ddThh:mm:ss.000Z" or empty string
	 */
	export function viewDateToIsoDate(viewDate: string): string {
		if (!viewDate) {
			return '';
		}

		try {
			const pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
			return new Date(viewDate.replace(pattern, '$3-$2-$1')).toISOString();
		} catch (e) {
			AppUtils.Helper.logInfo('Conversion from viewDateToIsoDate failed', 'Utils.Format', window.location.href, `Error message: ${e.message}`);
			return '';
		}
	}

	export function viewDateToDateOnly(viewDate: string): string {
		if (!viewDate) {
			return '';
		}

		try {
			const pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
			return viewDate.replace(pattern, '$3-$2-$1');
		} catch (e) {
			AppUtils.Helper.logInfo('Conversion from viewDateToDateOnly failed', 'Utils.Format', window.location.href, `Error message: ${e.message}`);
			return '';
		}
	}

	export function formatIsoDate(isoDate: string, format: string): string {
		if (!isoDate) {
			return '';
		}
		const date = new Date(isoDate);
		return moment(date).format(format);
	}

	/**
	 * Converts a date in iso format "yyyy-MM-ddThh:mm:ss.000Z" to format "DD.MM.YYYY".
	 *
	 * @param isoDate - iso date in format "yyyy-MM-ddThh:mm:ss.000Z", may be undefined/empty
	 * @returns date in format "DD.MM.YYYY" or empty string
	 */
	export function isoDateToViewDate(isoDate: string): string {
		return AppUtils.Format.formatIsoDate(isoDate, 'DD.MM.YYYY');
	}

	/**
	 * Converts a date in iso format "yyyy-MM-ddThh:mm:ss.000Z" to format "YYYY-MM-DD".
	 *
	 * @param isoDate - iso date in format "yyyy-MM-ddThh:mm:ss.000Z", may be undefined/empty
	 * @return date in format "DD.MM.YYYY" or empty string
	 */
	export function isoDateToShortIsoDate(isoDate: string): string {
		return AppUtils.Format.formatIsoDate(isoDate, ISODATE_SHORT);
	}

	export function viewDateToShortIsoDate(viewDate: string | Date | moment.Moment): string {
		return viewDate ? moment(viewDate).format(ISODATE_SHORT) : '';
	}

	export function viewDateToShortInvIsoDate(viewDate: string | Date | moment.Moment): string {
		return viewDate ? moment(viewDate).format(ISODATE_SHORT_INV) : '';
	}

	export function parseDateOffset(offset: string): moment.Moment {
		const pattern = /([+-]?[0-9]+)\s*(d|w|m|y)?/g;
		offset = offset.toLowerCase();
		let result = moment();
		let matches = pattern.exec(offset);
		while (matches) {
			switch (matches[2] || "d") {
				case "d":
					result = result.add(parseInt(matches[1], 10), "days");
					break;

				case "w":
					result = result.add(parseInt(matches[1], 10), "weeks");
					break;

				case "m":
					result = result.add(parseInt(matches[1], 10), "months");
					break;

				case "y":
					result = result.add(parseInt(matches[1], 10), "years");
					break;
			}
			matches = pattern.exec(offset);
		}

		return result;
	}

	/**
	 * Converts a decimal number to a currency number with ',' separator, 2 decimals and '.' separator for thousands.
	 * This format is used normally used to view price information.
	 *
	 * @param number - decimal number to format.
	 * @return currency string with ',' separator and 2 decimals.
	 */
	export function numberToCurrencyWith2Decimals(number: string | number): string {
		return $.number(number, 2, ',', '.');
	}

	export function bytesToSize(bytes: number, decimals?: number): string {
		if (bytes === 0) {
			return '0 Bytes';
		}
		const k = 1024,
			dm = decimals || 0,
			sizes = ['Bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
			i = Math.floor(Math.log(bytes) / Math.log(k));
		return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
	}

	export function formatCountrySpecificPhoneNumber(phoneNumber: string): string {
		const countriesWithSkiped0 = ['+33', '+49', '+41', '+31', '+43'];
		const parts = /^(\+\d\d)?(\d+)$/.exec(phoneNumber);
		if (!parts || parts.length < 3) {
			return phoneNumber;
		}
		if (countriesWithSkiped0.indexOf(parts[1]) > -1) {
			return parts[1] + parts[2].replace(/^0/, "");
		}

		return phoneNumber;
	}
}
